import { attributeTypes } from '@nsr/react-query-builder-executor';
import get from 'lodash/get';
import set from 'lodash/set';
const { VariableType } = require('json-to-graphql-query');

const blankQuery = { groups: [], where: [] };

export const getBlankQuery = () => ({ ...blankQuery });

export const buildQueryJson = (attributes) => {
    if (!attributes) {
        return { groups: [], where: [] };
    }
    return {
        groups: [
            {
                id: 'id',
                condition: 'AND'
            }
        ],
        where: buildWhereAttribute(attributes)
    };
};

export const buildWhereAttribute = (attributes, groupIds = 'id') => {
    const where = [];
    if (!Array.isArray(attributes)) {
        attributes = [attributes];
    }
    attributes?.forEach((att) => {
        if (att && att?.filterText && att?.type) {
            where[where.length] = {
                attribute: att,
                operator: getOperatorByType(att.type),
                value: getValue(att.type, att.filterText),
                groupIds: [groupIds]
            };
        }
    });
    return where;
};

const getValue = (type, value) => {
    switch (type) {
        case attributeTypes.lookup:
            return { id: value };
        default:
            return value;
    }
};

const getOperatorByType = (type) => {
    switch (type) {
        case attributeTypes.string:
            return 'CONTAINS';
        case attributeTypes.enum:
        case attributeTypes.date:
        case attributeTypes.lookup:
            return 'EQ';
        default:
            break;
    }
};

export const buildModelAttributeObject = (attributes) => {
    if (!attributes || attributes.length === 0) {
        return [];
    }
    const resultObj = {};
    for (const att of attributes) {
        const { value: modelAttributeName, path = [], type: attributeType = '' } = att;

        if (Array.isArray(path) && path.length > 0) {
            const pathValues = path.map(p => p.value);
            if (attributeType === attributeTypes.lookup) {
                set(resultObj, `${pathValues.join('.')}.${modelAttributeName}.title`, true);
            } else {
                set(resultObj, `${pathValues.join('.')}.${modelAttributeName}`, true);
            }
        }
        else {
            resultObj[modelAttributeName] = attributeType === attributeTypes.lookup ? { title: true } : true;
        }
    }
    return resultObj;
};

export const buildModelAttributeForSorting = (modelAttributeName, path = [], attributeType = '') => {
    if (!modelAttributeName) {
        return {};
    }
    let newModelAttributeObject = { [modelAttributeName]: new VariableType('sortDirection') };
    if (attributeType === attributeTypes.lookup) {
        newModelAttributeObject = { [modelAttributeName]: { 'title': new VariableType('sortDirection') } };
    }
    if (Array.isArray(path) && path.length > 0) {
        for (let x = path.length - 1; x >= 0; x--) {
            newModelAttributeObject = { [path[x].value]: newModelAttributeObject };
        }
    }
    return newModelAttributeObject;
};

export const isQueryEmpty = (query) => {
    return !query || !query?.where || query?.where?.length === 0;
};

export const buildModelAttributeForFilter = (modelAttributeName, filterText = '', path = [], attributeType = '') => {
    if (!modelAttributeName) {
        return {};
    }
    let newModelAttributeObject = { [modelAttributeName]: { CONTAINS: filterText } };
    if (attributeType === attributeTypes.lookup) {
        newModelAttributeObject = { [modelAttributeName]: { 'title': { CONTAINS: filterText } } };
    }
    if (Array.isArray(path) && path.length > 0) {
        for (let x = path.length - 1; x >= 0; x--) {
            newModelAttributeObject = { [path[x].value]: newModelAttributeObject };
        }
    }
    return newModelAttributeObject;
};

export const mapAttributesToResults = (attributes, results, codeField = undefined) => {
    if (!attributes || attributes.length === 0 || !results || results.length === 0) {
        return results;
    }
    // If any of the attributes in the result if an array, just take the first element
    // Not sure if there is a better way to handle array values for an attribute
    const resultsWithoutArray = results.map(res => {
        const newResult = {};
        Object.keys(res).forEach(r => {
            if (typeof res[r] !== 'object' && !Array.isArray(res[r])) {
                newResult[r] = res[r];
                return;
            }
            if (Array.isArray(res[r])) {
                res[r] = res[r].length > 0 ? res[r][0] : null;
            }
            let iter = res[r];
            while (typeof iter === 'object' && iter !== null) {
                Object.keys(iter).forEach(it => {
                    if (Array.isArray(iter[it])) {
                        iter[it] = iter[it].length > 0 ? iter[it][0] : null;
                    }
                    else {
                        iter = iter[it];
                    }
                });
            }
            newResult[r] = res[r];
        });
        return newResult;
    });
    const newResults = resultsWithoutArray.map(res => {
        const newResult = {};
        if (res.id && !attributes.some(att => att.value === 'id')) {
            newResult.id = res.id;
        }
        attributes.forEach(att => {
            if (!att.path || att.path.length === 0) {
                newResult[att.value] = att.type === attributeTypes.lookup ? res[att.value]?.title : res[att.value];
                return;
            }
            const pathValues = att.path.map(p => p.value);
            const keyName = `${pathValues.join('.')}.${att.value}`;
            if (att.type === attributeTypes.lookup) {
                newResult[keyName] = get(res, `${keyName}.title`, null);
            } else {
                newResult[keyName] = get(res, keyName, null);
            }
        });

        if (codeField && !newResult[codeField]) {
            newResult[codeField] = get(res, codeField);
        }

        return newResult;
    });
    return newResults;
};
